"use strict";
// list of slugs associated with valley files.
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRandomSampleRecords = exports.gatherMatchingData = exports.consolidateMatchingRecords = exports.generateRelationGraph = exports.getGraphNode = exports.createValleyFileGraph = exports.getSearchableFileAndKeys = exports.relationships = exports.isValleyFile = exports.expectedFiles = void 0;
const common_1 = require("@finley-technologies/common");
// here we can add more metadata to power any tooling (scripts, ui, etc)
exports.expectedFiles = {
    vanProduct: {},
    vanCust: {},
    vanCustAcctRel: {},
    psPlusAccount: {},
    psPlusPortfolio: {},
    psPlusSecDetail: {},
    psPlusSecMaster: {},
    collatCustRel: {},
    cuoCollat: {},
    cuoDeposit: {},
    cuoLoan: {},
    cuoMaint: {},
    loanCustRel: {},
    vanCmmt: {},
    vanDepAcct: {},
    vanList: {},
    vanLoanAcct: {},
    bloombergMutualFund: {},
    derivativePath: {},
};
const isValleyFile = (file) => {
    return file in exports.expectedFiles;
};
exports.isValleyFile = isValleyFile;
exports.relationships = {
    'vanCust:cif_num=>vanCustAcctRel:cif_num': {
        canSearch: true,
    },
    'vanCust:officer_code=>vanList:code': {},
    'vanCust:cif_num=>collatCustRel:cif_num': {},
    'vanCust:cif_num=>psPlusPortfolio:cif_num': {},
    'vanCust:cif_num=>cuoDeposit:cif_num': {},
    'cuoCollat:hecoll_id=>collatCustRel:hecoll_id': {},
    'collatCustRel:hecoll_id=>cuoCollat:hecoll_id': {},
    'vanCust:cif_num=>vanLoanAcct:cif_num': {
        transform: (data) => {
            return String(data).padStart(11, '0');
        },
    },
    // 'vanLoanAcct:cif_num=>vanCust:cif_num': {
    //   // its interesting that the data is not always padded
    //   // hence we allow this reverse search.
    //   canSearch: true,
    // },
    'vanDepAcct:account_id=>cuoCollat:hecoll_deposit_account_num': {
        canSearch: true,
    },
    'vanDepAcct:account_num=>vanCustAcctRel:account_id': {},
    'vanDepAcct:account_type_code=>vanList:code': {},
    'vanDepAcct:product_code=>vanProduct:product_code': {},
    'vanLoanAcct:commitment_id=>vanCmmt:commitment_id': {
        canSearch: true,
    },
    'vanLoanAcct:loan_id=>vanCustAcctRel:account_id': {
        canSearch: true,
    },
    'vanLoanAcct:loan_type_code=>vanList:code': {},
    'vanLoanAcct:status_code=>vanList:code': {},
    'vanCustAcctRel:account_id=>vanDepAcct:account_num': {
        canSearch: true,
    },
    // 'vanCustAcctRel:cif_num=>vanCust:cif_num': {},
    'vanCustAcctRel:account_id=>vanLoanAcct:loan_id': {
        canSearch: true,
    },
    'psPlusSecMaster:he_sec_security_num=>bloombergMutualFund:security_number': {
        canSearch: true,
    },
    'psPlusSecMaster:he_sec_security_num=>psPlusSecDetail:he_sec_security_num': {},
    'psPlusPortfolio:hecoll_id=>psPlusSecDetail:hecoll_id': {
        canSearch: true,
    },
    'psPlusPortfolio:hecoll_id=>psPlusAccount:hecoll_id': {},
    'loanCustRel:heloan_acct_num=>cuoDeposit:hedeposit_acct_num': {
        canSearch: true,
    },
    'cuoDeposit:hedeposit_acct_num=>loanCustRel:heloan_acct_num': {
        canSearch: true,
    },
    'cuoDeposit:hedeposit_acct_num=>cuoCollat:hecoll_deposit_account_num': {},
    'collatCustRel:he_coll_id=>cuoCollat:hecoll_id': {
        canSearch: true,
    },
};
const getSearchableFileAndKeys = () => Object.entries(exports.relationships)
    .filter(([_key, value]) => {
    return value.canSearch;
})
    .map(([relationshipKey]) => {
    const [src, _dest] = relationshipKey.split('=>');
    const [file, key] = src.split(':');
    (0, common_1.finleyAssert)((0, exports.isValleyFile)(file), `!isValleyFile file: ${file}`);
    return { file, key };
});
exports.getSearchableFileAndKeys = getSearchableFileAndKeys;
const createValleyFileGraph = (ingestedFiles) => {
    const graph = {
        nodes: new Map(),
        stats: [],
    };
    ingestedFiles.forEach((ingestedFile) => {
        // add index to every record, to help identify the record in the file.
        const data = ingestedFile.data.map((record, __index) => {
            return { ...record, __index };
        });
        const node = {
            file: ingestedFile.file,
            data,
            relationship: new Map(),
        };
        graph.nodes.set(node.file, node);
        graph.stats.push({
            file: ingestedFile.file,
            records: ingestedFile.data.length,
        });
    });
    return graph;
};
exports.createValleyFileGraph = createValleyFileGraph;
const getGraphNode = (graph, file) => {
    const node = graph.nodes.get(file);
    (0, common_1.finleyAssert)(node, `!node for file in graph: ${file}`);
    return node;
};
exports.getGraphNode = getGraphNode;
const generateRelationGraph = (ingestedFiles) => {
    const graph = (0, exports.createValleyFileGraph)(ingestedFiles);
    // validate relationship fields.
    Object.entries(exports.relationships).forEach(([key, value]) => {
        const [src, dest] = key.split('=>');
        const [srcFile, srcKey] = src.split(':');
        const [destFile, destKey] = dest.split(':');
        const { transform } = value;
        (0, common_1.finleyAssert)((0, exports.isValleyFile)(srcFile), `!isValleyFile file: ${srcFile}`);
        (0, common_1.finleyAssert)((0, exports.isValleyFile)(destFile), `!isValleyFile file: ${destFile}`);
        const srcNode = (0, exports.getGraphNode)(graph, srcFile);
        (0, common_1.finleyAssert)(srcNode, `!srcNode for file: ${srcFile}`);
        const destNode = (0, exports.getGraphNode)(graph, destFile);
        (0, common_1.finleyAssert)(destNode, `!destNode for file: ${destFile}`);
        srcNode.relationship.set(destFile, { srcKey, destKey, transform });
    });
    return graph;
};
exports.generateRelationGraph = generateRelationGraph;
const gatherMatchingDataInternal = ({ records, graph, node, key, value, processed, }) => {
    const processingEntry = `${node.file}:${key}:${value}`;
    if (processed.has(processingEntry)) {
        return records;
    }
    processed.add(processingEntry);
    // find all matching records
    const matchingRecords = node.data
        .filter((record) => String(record[key]) === String(value))
        .map((record) => {
        return { ...record, __source: processingEntry };
    });
    records.push({ file: node.file, matchingRecords });
    matchingRecords.forEach((record) => {
        Array.from(node.relationship.keys()).forEach((destNodeKey) => {
            const relationship = node.relationship.get(destNodeKey);
            (0, common_1.finleyAssert)(relationship, `!relationship for destNodeKey: ${destNodeKey}`);
            const srcValue = record[relationship.srcKey];
            const destValue = relationship.transform
                ? relationship.transform(srcValue)
                : srcValue;
            gatherMatchingDataInternal({
                records,
                graph,
                node: (0, exports.getGraphNode)(graph, destNodeKey),
                key: relationship.destKey,
                value: destValue,
                processed,
            });
        });
    });
    return records;
};
const consolidateMatchingRecords = (matchingRecords) => {
    // matchingRecords may have multiple entries for each file
    // consolidate them into single entry
    const consolidatedRecords = matchingRecords.reduce((acc, record) => {
        const existingRecord = acc.find((r) => r.file === record.file);
        if (existingRecord) {
            existingRecord.matchingRecords.push(...record.matchingRecords);
        }
        else {
            acc.push(record);
        }
        return acc;
    }, []);
    return consolidatedRecords.filter((record) => record.matchingRecords.length > 0);
};
exports.consolidateMatchingRecords = consolidateMatchingRecords;
const gatherMatchingData = ({ graph, file, key, value, }) => {
    const node = (0, exports.getGraphNode)(graph, file);
    const matchingRecords = gatherMatchingDataInternal({
        records: [],
        graph,
        node,
        key,
        value,
        processed: new Set(),
    });
    return (0, exports.consolidateMatchingRecords)(matchingRecords);
};
exports.gatherMatchingData = gatherMatchingData;
const getRandomSampleRecords = (graph) => {
    const records = [];
    graph.nodes.forEach((node) => {
        const dataSize = node.data.length;
        let startIndex = 0;
        // If dataSize is greater than 5, calculate a random start index
        if (dataSize > 5) {
            const maxStartIndex = dataSize - 5;
            startIndex = Math.floor(Math.random() * (maxStartIndex + 1));
        }
        // If dataSize is 5 or less, it defaults to 0 which is fine
        const selectedRecords = node.data.slice(startIndex, startIndex + 5);
        records.push({ file: node.file, matchingRecords: selectedRecords });
    });
    return records;
};
exports.getRandomSampleRecords = getRandomSampleRecords;
//# sourceMappingURL=valleyFiles.js.map